// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewEmailFlowPopup_checkbox_text__l9dKe {
  font-size: small;
}
.NewEmailFlowPopup_checkbox_missing__hv7kb {
  color: red;
}

.NewEmailFlowPopup_confirm_disabled__8gIO9 {
  opacity: 0.5;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/NewEmailFlowPopup/NewEmailFlowPopup.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[".checkbox_text {\n  font-size: small;\n}\n.checkbox_missing {\n  color: red;\n}\n\n.confirm_disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox_text": `NewEmailFlowPopup_checkbox_text__l9dKe`,
	"checkbox_missing": `NewEmailFlowPopup_checkbox_missing__hv7kb`,
	"confirm_disabled": `NewEmailFlowPopup_confirm_disabled__8gIO9`
};
export default ___CSS_LOADER_EXPORT___;
